module.exports = __webpack_public_path__ + "img/collection-weddingRingsClassic.8953319.webp";